import { ActionIcon, Button, Flex, Text, Tooltip } from '@mantine/core';
import { IconFileText, IconX } from '@tabler/icons-react';
import * as React from 'react';

import { IconFolder } from '@/components/ui/icons/IconFolder';
import { useIsTextTruncated } from '@/hooks/useIsTextTruncated';

import s from './MobileHeader.module.scss';

type MobileHeaderProps = {
  showDocumentTitle: boolean;
  documentName?: string | null;
  contextType?: 'document' | 'folder';
  onClose: () => void;
  onChatClick?: () => void;
};

const MobileHeader: React.FC<MobileHeaderProps> = ({
  showDocumentTitle,
  documentName,
  contextType = 'document',
  onClose,
  onChatClick,
}) => {
  const Icon = contextType === 'folder' ? IconFolder : IconFileText;
  const [textRef, isTextTruncated] = useIsTextTruncated('width');

  return (
    <div className={s.root}>
      <Flex gap="xs" align="center" justify="space-between" className={s.root__row}>
        <Flex gap="xs" align="center" className={s.root__title}>
          {showDocumentTitle && documentName && (
            <>
              <Icon className={s.root__icon} size={16} color="red" />
              {isTextTruncated ? (
                <Tooltip
                  label={documentName}
                  withArrow
                  position="top"
                  events={{ hover: true, focus: false, touch: true }}
                  openDelay={500}
                >
                  <Text ref={textRef} size="sm" fw={500} lineClamp={1}>
                    {documentName}
                  </Text>
                </Tooltip>
              ) : (
                <Text ref={textRef} size="sm" fw={500} lineClamp={1}>
                  {documentName}
                </Text>
              )}
            </>
          )}
        </Flex>
        <Flex gap="xs" align="center">
          {onChatClick && (
            <Button
              variant="gradient"
              gradient={{ from: '#56AFFC', to: '#465CFF', deg: 107.33 }}
              size="xs"
              onClick={onChatClick}
            >
              Обсудить с ИИ
            </Button>
          )}
          <ActionIcon
            c="gray"
            color="gray"
            variant="light"
            radius="999"
            size="md"
            onClick={onClose}
            className={s.root__close}
          >
            <IconX size={18} />
          </ActionIcon>
        </Flex>
      </Flex>
    </div>
  );
};

export default React.memo(MobileHeader);
